import { CEProcessStepAssociationBase } from './ce-process-step-association-base'


export class CEProcessStepAssociation extends CEProcessStepAssociationBase {

}